// TODO: This can be removed when migrating from Angular uib-modals

import type {ActionReturn} from 'svelte/action';
import type {AnyObject} from 'typings/portaro.fe.types';
import {ignoreUnusedProperties} from 'shared/utils/custom-utils';

interface Parameters {
    isModalOpen?: boolean;
}

const defaultParams: Parameters = {
    isModalOpen: false
}

export function enforceModalOpen(node: HTMLElement, params: Parameters = defaultParams): ActionReturn<Parameters, AnyObject> {
    ignoreUnusedProperties(node); // We don't need HTML element reference

    const setModalOpenClassOnBody = (open: boolean) => {
        if (open) {
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }
    }

    setModalOpenClassOnBody(params.isModalOpen);

    return {
        update(parameters) {
            setModalOpenClassOnBody(parameters.isModalOpen);
        },
        destroy: () => setModalOpenClassOnBody(false)
    }
}